import { createSlice } from "@reduxjs/toolkit";
import { getInternalDeliveryOrderList, getInternalDeliveryOrderByID } from "./internalDeliveryOrderAction";

const internaldeliveryorderSlice = createSlice({
    name: "internaldeliveryorder",
    initialState: {
        error: "Sorry! No Data Found.",
        message: null,
        loading: false,        
        unitsLoading: false,
        model: false,
        error_msg: null,
        rowdata: {},
        listCount: 0,
        internaldeliveryorderlist: [],
        internaldeliveryorderParams: {
            no_of_pages: 0,
            page_size: 10,
            page: 1,
            search: "",
            currentSort: "code",
            sortOrder: "-",
        },
        
    },
    reducers: {
       
        InputChangeValue: (state, action) => {
            return {
                ...state,
                rowdata: {
                    ...state.rowdata,
                    [action.payload.key]: action.payload.value,
                },
            };
        },   
        SetInternalDeliveryOrderParams: (state, action) => {
            return {
                ...state,
                internaldeliveryorderParams: {
                    ...state.internaldeliveryorderParams,
                    ...action.payload
                },
            };
        },
        isModelVisible: (state, action) => {
            if (!action.payload) {
                return {
                    ...state,
                    model: action.payload,
                    rowdata: {},
                };
            } else {
                return {
                    ...state,
                    model: action.payload,
                };
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getInternalDeliveryOrderList.pending, (state, action) => {
                state.status = "getInternalDeliveryOrderList loading";
                state.loading = true;
            })
            .addCase(getInternalDeliveryOrderList.fulfilled, (state, action) => {
                state.status = "getInternalDeliveryOrderList succeeded";
                state.loading = false;
                var response = action.payload.response;
                var noofpages = Math.ceil(
                    action.payload.count / state.internaldeliveryorderParams?.page_size
                );

                state.internaldeliveryorderlist = response.results;
                state.listCount = response.count;
                state.internaldeliveryorderParams = {
                    ...state.internaldeliveryorderParams,
                    no_of_pages: noofpages,
                };
            })
            .addCase(getInternalDeliveryOrderList.rejected, (state, action) => {
                state.status = "getInternalDeliveryOrderList failed";
                state.loading = false;
                state.error = action.error.message;
            })
            
            .addCase(getInternalDeliveryOrderByID.pending, (state, action) => {
                state.status = "getInternalDeliveryOrderByID loading";
                state.loading = true;
            })
            .addCase(getInternalDeliveryOrderByID.fulfilled, (state, action) => {
                state.status = "getInternalDeliveryOrderByID succeeded";
                state.loading = false
                state.rowdata = action.payload;
            }
            )
            .addCase(getInternalDeliveryOrderByID.rejected, (state, action) => {
                state.status = "getInternalDeliveryOrderByID failed";
                state.loading = false;
                state.error = action.error.message;
            })
           
    }

});
export const {
    InputChangeValue,
    SetInternalDeliveryOrderParams,
    isModelVisible
} = internaldeliveryorderSlice.actions;

export default internaldeliveryorderSlice.reducer;